<template>
  <tech034 />
</template>

<script>
import tech034 from '@/pages/tech/p_tech034.vue';

export default {
  components: {
    tech034
  }
};
</script>
